import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../pages/sesion_viewer.css';

function Sesion_viewer() {
const [activeSection, setActiveSection] = useState('seguidores');
  const [usuario, setUsuario] = useState('');
  const [seguidos, setSeguidos] = useState([]);
  const [loadingSeguidos, setLoadingSeguidos] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const ITEMS_POR_PAGINA = 5;
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener nombre de usuario desde localStorage
    const userName = localStorage.getItem('userName');
    const userId   = localStorage.getItem('userId');

    if (!userName || !userId) {
      // Si no hay sesión activa redirigir al login
      navigate('/acceso_viewer');
      return;
    }

    setUsuario(userName);

    // Cargar lista de seguidos desde el backend
    setLoadingSeguidos(true);
    fetch(`${process.env.REACT_APP_SEGUIDOS_URL}/get_seguidos.php?id_viewer=${userId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setSeguidos(data.seguidos);
        }
      })
      .catch(err => console.error('Error al cargar seguidos:', err))
      .finally(() => setLoadingSeguidos(false));
  }, []);

const handleCerrarSesion = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('returnToProfile');
    navigate('/');
  };

  const handleSeguidoresClick = () => {
    setActiveSection('seguidores');
  };

  return (
    <div className="sesion-viewer-container">
      {/* BANNER SUPERIOR */}
      <div className="banner-sesion">
        <div className="info-sesion">
          <span className="texto-sesion">Sesion iniciada : Usuario :</span>
          <span className="nombre-usuario">{usuario}</span>
        </div>
        <button className="btn-cerrar-sesion" onClick={handleCerrarSesion}>
          CERRAR SESION
        </button>
        <button className="btn-inicio-viewer" onClick={() => navigate('/')}>
          INICIO
        </button>
      </div>

      {/* CONTENEDOR PRINCIPAL */}
      <div className="contenido-sesion">
        {/* SIDEBAR IZQUIERDO */}
        <div className="sidebar-opciones">
          <button 
            className={`btn-opcion ${activeSection === 'seguidores' ? 'active' : ''}`}
            onClick={handleSeguidoresClick}
          >
            Seguidores
          </button>
        </div>

        {/* �REA DE CONTENIDO */}
        <div className="area-contenido">
          {activeSection === 'seguidores' && (
            <div className="seccion-seguidos">
              <h2 className="titulo-seccion">SEGUIDOS</h2>
              
              <div className="tabla-seguidos">
                {/* ENCABEZADOS */}
                <div className="tabla-header">
                  <div className="col-siguiendo">Siguiendo</div>
                  <div className="col-fecha">Fecha</div>
                  <div className="col-valoracion">Valoracion</div>
                  <div className="col-seguidores">Seguidores</div>
                </div>

{/* FILAS DE DATOS */}
                {loadingSeguidos && (
                  <div className="tabla-fila">
                    <div style={{ padding: '20px', color: '#888' }}>Cargando seguidos...</div>
                  </div>
                )}

                {!loadingSeguidos && seguidos.length === 0 && (
                  <div className="tabla-fila">
                    <div style={{ padding: '20px', color: '#888' }}>Aún no sigues a nadie.</div>
                  </div>
                )}

{!loadingSeguidos && seguidos
                  .slice((paginaActual - 1) * ITEMS_POR_PAGINA, paginaActual * ITEMS_POR_PAGINA)
                  .map((seguido) => (
                  <div key={seguido.ID_Perfil} className="tabla-fila">
<div className="col-siguiendo">
                      <div className="avatar-wrapper">
                        <img
                          src={
                            seguido.fotos
                              ? `${process.env.REACT_APP_UPLOADS_URL}/ID_${seguido.ID_Perfil}/${seguido.fotos}`
                              : '/img/logo.png'
                          }
                          alt={seguido.nombre}
                          className="avatar-seguido"
                        />
                        <span className="nombre-seguido">{seguido.nombre}</span>
                      </div>
                    </div>
                    <div className="col-fecha">
                      {new Date(seguido.Fecha_seguidos).toLocaleDateString('es-CL')}
                    </div>
                    <div className="col-valoracion">
                      <span className="nota-label">Nota :</span>
                      <button
                        className="btn-valorar"
                        onClick={() => navigate(`/perfil?id=${seguido.ID_Perfil}&public=1`)}
                      >
                        Ir a valorar
                      </button>
                    </div>
                    <div className="col-seguidores">
                      <span style={{ fontWeight: '600', color: '#333' }}>
                        {seguido.total_seguidores || 0}
                      </span>
                    </div>
                  </div>
                ))}
</div>

              {/* PAGINACIÓN */}
              {seguidos.length > ITEMS_POR_PAGINA && (
                <div className="paginacion-container">
                  <button
                    className="btn-pagina"
                    onClick={() => setPaginaActual(prev => prev - 1)}
                    disabled={paginaActual === 1}
                  >
                    ← Anterior
                  </button>

                  <div className="paginas-numeros">
                    {Array.from({ length: Math.ceil(seguidos.length / ITEMS_POR_PAGINA) }, (_, i) => (
                      <button
                        key={i + 1}
                        className={`btn-pagina-numero ${paginaActual === i + 1 ? 'activo' : ''}`}
                        onClick={() => setPaginaActual(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>

                  <button
                    className="btn-pagina"
                    onClick={() => setPaginaActual(prev => prev + 1)}
                    disabled={paginaActual === Math.ceil(seguidos.length / ITEMS_POR_PAGINA)}
                  >
                    Siguiente →
                  </button>
                </div>
              )}
            </div>
          )}

          {!activeSection && (
            <div className="mensaje-bienvenida">
              <p>Selecciona una opcion del menu lateral</p>
            </div>
          )}
</div>
      </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
}

export default Sesion_viewer;